<template>
  <div class="rj-page-card">
    <div class="rj-page-card__title">
      货运信息
    </div>
    <div class="rj-page-card__content">
      <div class="rj-row">
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              运输方式：
            </div>
            <div class="rj-baseinfo__item">
              {{ form.shippingType ? '航空' : '陆运' }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              承运商：
            </div>
            <div class="rj-baseinfo__item">
              {{ form.carrier }}
            </div>
          </div>
        </div>
        <div v-if=" parseInt(form.freight) !== 0 && form.freight !==null" class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              运费支付方式：
            </div>
            <div class="rj-baseinfo__item">
              {{ form.freightPayType ? '返利' : '现金' }}
            </div>
          </div>
        </div>
        <div v-if="parseInt(form.freight) !== 0 && form.freight !==null && form.freightPayType" class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              返利金额：
            </div>
            <div class="rj-baseinfo__item">
              <template>
                {{ form.freight }} 元
                <rebate-use :freight="form.freight" :form="form" :allow="allowUserRate" @chooesSuccess="chooesSuccess" />
                {{ rebateAmount }} 元
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { MathMulti } from '@/libs/util';
// import { freightDifference } from '@/API/index.js';
import rebateUse from './rabateUse';
export default {
  props: {
    form: {
      type: Object,
      default: () => { return {}; }
    }
  },
  components: {
    rebateUse
  },
  computed: {
    allowUserRate () {
      return MathMulti(this.form.orderSales, 0.3);
    }
  },
  data () {
    return {
      rebateAmount: null,
      rebateUsedList: []
    };
  },
  mounted () {

  },
  methods: {
    chooesSuccess (val) {
      this.rebateAmount = val.total;
      this.rebateUsedList = val.list;
    },
    // 验证必填项，如果验证通过，返回info对象
    validate () {
      let error = '';
      if (this.form.freightPayType && parseInt(this.rebateAmount) !== parseInt(this.form.freight)) {
        error = '请选择返利';
      }
      if (error) {
        this.$notify.error({
          title: error
        });
        return false;
      } else {
        let useRebateVO = {
          contractNum: this.form.contractNum,
          orderAmount: this.form.orderSales,
          projectName: this.form.projectName,
          rebateListVo: this.rebateUsedList
        };
        return useRebateVO;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.rj-page-card__content .item {
  display: inline-block;
}
.rj-page-card__content span {
  display: inline-block;
  margin-left: 40px;
}
</style>
